import gql from 'graphql-tag';
import { FRAGMENT_BOOKING, FRAGMENT_BOOKING_LINK } from './booking';

export const QUERY_INSTALLMENTS_FOR_SELECTION = gql`
  query SP_QueryInstallmentsForSelection(
    $propertyId: ID!
    $filter: getInstallmentsForSelectionInput!
  ) {
    getInstallmentsForSelection(propertyId: $propertyId, filter: $filter) {
      installments {
        installmentId
        installmentType
        installmentName
        description
        discountAmount
        installmentNumbers
        discountAmount
        isMarketingDefault
        specialOfferCount
        guarantorSettings {
          id
          guarantorType
        }
        specialOffers {
          id
          name
          discountItemType
          discountType
          discountValue
          discountRule
          channel {
            id
            type
          }
        }
      }
    }
  }
`;

export const QUERY_INSTALLMENT_WITH_PLANS = gql`
  query SP_QueryInstallmentWithPlans($propertyId: ID!, $filter: getInstallmentWithPlansInput!) {
    getInstallmentWithPlans(propertyId: $propertyId, filter: $filter) {
      totalPrice
      installmentDataHash
      installmentWithPlans {
        installmentId
        installment {
          ... on FullInstallment {
            installmentType
          }
          ... on MonthlyInstallment {
            installmentType
          }
          ... on FortnightlyInstallment {
            installmentType
          }
          ... on WeeklyInstallment {
            installmentType
          }
          ... on CustomizedInstallment {
            installmentType
          }
        }
        installmentPlans {
          dueDate
          amount
          isDueBeforeBookingConfirmed
          partOfRentAdditionalFeeDeduct
          partOfRentAdditionalFees {
            name
          }
        }
      }
      paymentDueNow {
        amountDue
        details {
          name
          amount
          description
        }
      }
      additionalFees {
        additionalFeeCardConfigId
        name
        dueDate
        dueAmount
        feature
        description
        installmentIndex
        installmentNumber
        taxRateId
        taxRate
        taxAmount
        salesItemId
        dueAmountWithTax
        isDueBeforeBookingConfirmed
      }
      bookingTotalFeeDetail {
        rent {
          tenancyLength
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        services {
          name
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        additionalFees {
          name
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        specialOffer {
          name
          amount
        }
        refundableFees {
          name
          amount
        }
        totalFee
      }
    }
  }
`;

export const MUTATION_STUDENT_UNBLOCK_HELD_BED = gql`
  mutation SP_MutationStudentUnblockHeldBed($bookingId: ID!) {
    studentUnblockHeldBed(bookingId: $bookingId) {
      status
    }
  }
`;

export const MUTATION_STUDENT_EDIT_BOOKING = gql`
  mutation SP_MutationStudentEditBooking($input: studentEditBookingInput!) {
    studentEditBooking(input: $input) {
      ...fragmentQueryBooking
    }
  }
  ${FRAGMENT_BOOKING}
`;

export const QUERY_NODE_BED = gql`
  query SP_QueryNodeBed($id: ID) {
    node(id: $id) {
      ... on Bed {
        id
        name
        type {
          name
          bedWidth
          bedLength
        }
        room {
          roomSize
          disabilityAccess
        }
        floor {
          name
        }
        building {
          name
        }
        flat {
          id
          name
          bathroomType
          kitchenOrLaundryArea
          bathroomArrangement
          kitchenArrangement
        }
        property {
          addressLine1
          addressLine2
          postalCode
          city {
            name
          }
          country {
            name
          }
        }
      }
    }
  }
`;

export const QUERY_NODE_ROOMTYPE = gql`
  query SP_QueryNodeRoomType($id: ID) {
    node(id: $id) {
      ... on RoomType {
        id
        name
        originId
        kitchenArrangement
        bathroomArrangement
        category
        hasPrice
      }
    }
  }
`;

export const QUERY_GET_PREFERENCE_FOR_FLAT = gql`
  query SP_QueryGetPreferenceForFlat($input: getPreferenceForFlatInput!) {
    getPreferenceForFlat(input: $input) {
      gender
      dietary
      smoking
      pet
    }
  }
`;

export const MUTATION_STUDENT_SELECT_INSTALLMENT = gql`
  mutation SP_MutationStudentSelectInstallment(
    $propertyId: ID!
    $input: studentSelectInstallmentInput!
  ) {
    studentSelectInstallment(propertyId: $propertyId, input: $input) {
      id
      status
      countDown
      totalPrice
      totalPriceAfterTax
      documents {
        id
        name
        status
        stage
        fileUuid
        category
        mandatory
        description
        rejectedReason
      }
      guarantorSettings {
        id
        academicYearId
        guarantorType
        guarantorTypeLabelName
        guarantorTypeDescription
      }
      installment {
        name
        installmentId
        installmentType
      }
      installmentPlans {
        dueDate
        amountDue
        isDueBeforeBookingConfirmed
        partOfRentAdditionalFeeDeduct
        partOfRentAdditionalFees {
          name
        }
      }
      checkOutCartInfo {
        totalAmountToBePaid
        paymentDueNow {
          amountDue
          details {
            name
            amount
            description
          }
        }
        bookingTotalFeeDetail {
          rent {
            tenancyLength
            amountAfterTax
            originalAmount
            taxInfo {
              taxRate
              amount
              includedInPrice
            }
          }
          services {
            name
            amountAfterTax
            originalAmount
            taxInfo {
              taxRate
              amount
              includedInPrice
            }
          }
          additionalFees {
            name
            amountAfterTax
            originalAmount
            taxInfo {
              taxRate
              amount
              includedInPrice
            }
          }
          specialOffer {
            name
            amount
          }
          refundableFees {
            name
            amount
          }
          totalFee
        }
      }
    }
  }
`;

export const MUTATION_STUDENT_ACCEPT_TREMS = gql`
  mutation SP_MutationStudentAcceptTerms($bookingId: ID!) {
    studentAcceptTerms(bookingId: $bookingId) {
      id
      status
      countDown
      bookingLink {
        ...fragmentBookingLink
      }
      invoicedPaymentItems {
        id
        modelType
        category
        description
        currency
        paidAmount
        totalAmount
        status
        isDueBeforeBookingConfirmed
        chargeCreated
      }
    }
  }
  ${FRAGMENT_BOOKING_LINK}
`;

export const MUTATION_STUDENT_ACCEPT_TREMS_FOR_AMENDMENT = gql`
  mutation SP_MutationStudentAcceptTermsForAmendment($bookingId: ID!) {
    studentAcceptTermsForAmendment(bookingId: $bookingId) {
      id
      status
      latestAmendmentDetail {
        status
      }
      bookingLink {
        sourceAcceptedAt
      }
    }
  }
`;

export const QUERY_APPLY_PROMOTION_CODE = gql`
  query SP_QueryApplyPromotionCode($propertyId: ID!, $filter: applyPromotionCodeInput!) {
    applyPromotionCode(propertyId: $propertyId, filter: $filter) {
      specialOffer {
        id
        name
        discountItemType
        discountType
        discountValue
        discountRule
        channel {
          id
          type
        }
      }
      discountAmount
    }
  }
`;

export const QUERY_GET_SPECIAL_OFFER = gql`
  query SP_QueryGetSpecialOffer(
    $propertyId: ID!
    $specialOfferId: ID
    $promotionCode: NonEmptyString
  ) {
    getSpecialOffer(
      propertyId: $propertyId
      specialOfferId: $specialOfferId
      promotionCode: $promotionCode
    ) {
      id
      name
      discountType
      discountItemType
      discountValue
      academicYear {
        id
        name
      }
      criteria {
        id
        criterionType
        tenancyOptions {
          id
          name
        }
        installments {
          full {
            name
          }
          weekly {
            name
          }
          fortnightly {
            name
          }
          monthly {
            name
          }
          customized {
            name
          }
        }
        roomTypes {
          id
          name
        }
        symbol
        amount
        unit
      }
    }
  }
`;
